import type { Uuid } from '@common/types';
import type { WidgetErrorItem } from '@common/types/widget-errors.type';

import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';

import WidgetsErrorsActions from './widgets-errors.actions';

export const WIDGETS_ERRORS_FEATURE_KEY = 'widgetsErrors';

export type WidgetsErrorsState = Record<Uuid, WidgetErrorItem>;

export const initialWidgetsErrorsState: WidgetsErrorsState = {};

export const widgetsErrorsReducer = createImmerReducer<WidgetsErrorsState>(
    initialWidgetsErrorsState,
    on(WidgetsErrorsActions.setWidgetsErrors, (state: WidgetsErrorsState, { errors }) => ({ ...errors })),
    on(WidgetsErrorsActions.updateWidgetError, (state: WidgetsErrorsState, { error, id }) => {
        if (!error?.errors?.length) {
            delete state[id];
            return state;
        }

        state[id] = error;
        return state;
    }),
    on(WidgetsErrorsActions.removeWidgetErrors, (state: WidgetsErrorsState, { widgetId }) => {
        delete state[widgetId];
        return state;
    })
);
